import { baseQuery } from '../baseQuery';
import { ServiceTypeAvailability } from 'types';

type PostTechnicianServiceTypePayload = {
  techId: number;
  service_type_ID: number;
  status: ServiceTypeAvailability;
};

export const postTechnicianServiceType = async (payload: PostTechnicianServiceTypePayload) => {
  const { techId, ...rest } = payload;
  const { data } = await baseQuery(`technicians/${techId}/service-types`, {
    type: 'POST',
    body: {
      ...rest,
    },
  });

  return data;
};
